module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticStyle: {
      "margin-top": "20px",
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.mainForm,
      "label-width": "120px",
      "rules": _vm.mainFormRules
    }
  }, [(_vm.mainForm.pwdreset == true) ? _c('el-col', {
    staticStyle: {
      "background-color": "#ff9900",
      "color": "white",
      "padding": "15px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          Your password has expired and needs to be reset. Please enter a new value in the password field below.'.\n          ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Login : ",
      "prop": "Usercode"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "disabled",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.mainForm.usercode),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "usercode", $$v)
      },
      expression: "mainForm.usercode"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name :",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.mainForm.Usercode == 'master',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.mainForm.username),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "username", $$v)
      },
      expression: "mainForm.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Your Avatar:",
      "prop": "useravatar"
    }
  }, [_c('img', {
    staticClass: "icoon",
    attrs: {
      "src": _vm.curIcon
    }
  }), _vm._v(" "), (_vm.mainForm.usercode != 'master') ? _c('el-select', {
    attrs: {
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "value-key": "mainForm.useravatar",
      "placeholder": "Select Icon"
    },
    on: {
      "change": _vm.showChanged
    },
    model: {
      value: (_vm.mainForm.useravatar),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "useravatar", $$v)
      },
      expression: "mainForm.useravatar"
    }
  }, _vm._l((_vm.codes.Img), function(item) {
    return _c('el-option', {
      key: item.Code,
      staticStyle: {
        "height": "45px"
      },
      attrs: {
        "label": item.Desc,
        "value": item.Url
      }
    }, [_c('img', {
      staticClass: "icoon",
      attrs: {
        "src": item.IconUrl
      }
    }), _c('span', {
      staticStyle: {
        "margin": "5px 10px",
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.Desc))])])
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.mainForm.usercode != 'master') ? _c('el-col', {
    staticStyle: {
      "background-color": "#ddd",
      "padding-top": "10px",
      "xmargin-top": "10px"
    }
  }, [(_vm.mainForm.pwdreset == false) ? _c('div', {
    staticStyle: {
      "font-family": "verdana",
      "font-size": "12px",
      "color": "blue",
      "font-weight": "bold",
      "margin": "0 0 10px 20px"
    }
  }, [_vm._v("\n          Only use these fields if you want to change your password ! ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "label": "Password :",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.mainForm.password),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "password", $$v)
      },
      expression: "mainForm.password"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mainForm.usercode != 'master') ? _c('el-col', {
    staticStyle: {
      "background-color": "#ddd",
      "padding-bottom": "20px",
      "margin-bottom": "10px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Re-Type PWD :",
      "prop": "password2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.mainForm.password2),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "password2", $$v)
      },
      expression: "mainForm.password2"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [(_vm.mainForm.usercode != 'master') ? _c('el-button', {
    staticStyle: {
      "float": "Right"
    },
    attrs: {
      "type": "success",
      "size": "small",
      "loading": _vm.mainLoading,
      "icon": "el-icon-edit"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mainSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Store")]) : _vm._e(), _vm._v(" "), (_vm.mainForm.usercode == 'master') ? _c('div', {
    staticStyle: {
      "font-family": "verdana",
      "margin-left": "px"
    }
  }, [_vm._v(" User 'master' cannot be modified. Please contact admin!")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61a7e2c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/xprofile.vue
// module id = 645
// module chunks = 1